import { useMemo } from 'react';

export const useMergedRefs = (...refs: React.RefObject<Element | null>[]) => {
    return useMemo(() => {
        if (refs.every((ref) => ref === null)) {
            return null;
        }

        return (value: Element | null) => {
            refs.forEach((ref) => {
                if (typeof ref === 'function') {
                    (ref as React.RefCallback<Element | null>)(value);
                } else if (ref != null) {
                    ref.current = value;
                }
            });
        };
    }, refs);
};
